export class StorageError extends Error {
  public readonly key: string | null = null;
  constructor(message: string, key: string | null = null) {
    super(message);
    this.name = "StorageError";
    this.key = key;
  }
}
